/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import {
  dispatchManufacturersData,
  getDrugFamily,
  setDrugFamilyTableData,
} from '../../store/actions';

export default (props) => {
  const { value, column } = props;

  let handledValue = value;
  if (props?.column.colId === 'ccCommentexists')
    handledValue = !!(value === 1 || value === '1');
  if (props?.column.colId === '')
    handledValue = !!(value === 1 || value === '1');

  const dispatch = useDispatch();

  const manufacturersData =
    useSelector(
      (state) => state.sharedState.URASearchReducer?.manufacturersData
    ) ?? [];
  const DrugFamilyTableData =
    useSelector(
      (state) => state.sharedState.URASearchReducer?.DrugFamilyTableData
    ) ?? [];
  const URASearchFormValues = useSelector(
    (state) => state.sharedState.URASearchReducer?.URASearchFormValues
  );

  let rowIndex = 0;
  rowIndex = manufacturersData.findIndex((x) => {
    return x.mfgId === props?.data?.mfgId;
  });

  // handing onClick event & check validation on filed level
  const handleOnClickEvent = (e) => {
    if (props?.column.colId === 'ccCommentexists') return false;
    const newObj = [...manufacturersData];
    const newValue = e.target.checked;
    newObj[rowIndex][props?.column.colId] = newValue;
    props.node.setDataValue(props?.column.colId, newValue);
    if (props?.column.colId === 'isChecked') {
      dispatch(dispatchManufacturersData(newObj));
      if (newValue) {
        dispatch(
          getDrugFamily({
            mfgId: newObj[rowIndex]?.mfgId,
            qtrType: 'ALL',
            rpc: URASearchFormValues.rebateProgramCd,
          })
        );
      } else {
        dispatch(
          setDrugFamilyTableData(
            DrugFamilyTableData?.filter(
              (item) => item.mfgId !== newObj[rowIndex]?.mfgId
            )
          )
        );
      }
    }
  };

  return (
    <>
      <div
        className="tbl-checkbox frr-checkbox-no-label"
        data-testid="checkbox-com"
      >
        <FormControlLabel
          label="check"
          data-testid="common-chk"
          control={<Checkbox color="primary" />}
          checked={handledValue}
          value={handledValue}
          onClick={(e) => {
            handleOnClickEvent(e);
          }}
        />
      </div>
    </>
  );
};
